export default "__VITE_ASSET__5fd93d04__"